import React from 'react';
import {
  Dropdown,
  MenuItem,
  FormController,
  FormLabel,
} from '@one-thd/sui-atomic-components';

import { useFormContext } from 'react-hook-form';
import { IDropdownProps } from '../../../models/common/dropdown';
import { TCity } from '../../../models/common/city-state';

export const formatCityState = (city: string, state: string) => {
  return `${city}, ${state}`;
};

export const CityStateSelect = React.forwardRef(
  (props: IDropdownProps & { cities: Array<TCity> | null }, ref) => {
    const { cities } = props;
    const values: { [key: string]: TCity } = {};
    const { setValue } = useFormContext();

    // Onchange, set values of city and state separately
    const handleCityStateChange = (
      event: React.ChangeEvent<HTMLInputElement>,
    ) => {
      setValue('city', values[event.target.value]?.city ?? '');
      setValue('state', values[event.target.value]?.stateProvince ?? '');
      setValue('cityState', event.target.value);
    };

    return (
      <FormController fullWidth>
        <FormLabel>City, State*</FormLabel>
        <Dropdown
          label={props.value}
          ref={ref}
          placeholder=""
          {...props}
          onChange={handleCityStateChange}
        >
          {cities?.length &&
            cities.map(({ city, stateProvince }) => {
              values[formatCityState(city, stateProvince)] = {
                city,
                stateProvince,
              };
              return (
                <MenuItem
                  key={city}
                  value={formatCityState(city, stateProvince)}
                >
                  {formatCityState(city, stateProvince)}
                </MenuItem>
              );
            })}
        </Dropdown>
      </FormController>
    );
  },
);
